import MDTypography from "common/components/MD/MDTypography";
import Grid from "@mui/material/Grid";
import currencyFormat from "common/script/currencyFormat"

import PropTypes from "prop-types";


function Opzione_avi({ q_avi,tot_riga }) {
    return (
        <Grid container spacing={2} mb={2} columns={10} sx={{
            fontSize: 12,
            boxShadow: 2,
            border: 2,
            borderColor: '#ff9800',
            '& .MuiDataGrid-cell:hover': {
                color: '#ff9800',
            },
        }}>



            <Grid item sm={10} md={10} lg={10} >
                <MDTypography variant="button" fontWeight="bold" sx={{ color: '#ff9800' }}>SETTORI MERCEOLOGICI AMMESSI: Avicunicoli</MDTypography>

            </Grid>

            <Grid item sm={10} md={10} lg={10} >
                <MDTypography variant="caption" fontWeight="regular" >
                   La tariffa comprende: area espositiva, gazebo di copertura, servizio antincendio, presa elettrica 16 A/220v (1kW), inviti ridotti, pass allevatori, pass auto.    </MDTypography>
            </Grid>
            <Grid item sm={2} md={2} lg={2} >
                <MDTypography variant="overline" fontWeight="medium" >
                GAZEBO</MDTypography>
            </Grid>


            <Grid item xs={3} md={3} >
                <MDTypography variant="overline" fontWeight="medium" sx={{ textAlign: 'left' }} >
                    SETTORI AMMESSI</MDTypography>
            </Grid>

       
            <Grid item xs={1} md={1} >
                <MDTypography variant="overline" fontWeight="medium" >
                    N°</MDTypography>
            </Grid>
            <Grid item xs={2} md={2} >
                <MDTypography variant="overline" fontWeight="medium" >
                    PREZZO UNITARIO</MDTypography>
            </Grid>
            <Grid item xs={2} md={2} >
                <MDTypography variant="overline" fontWeight="medium" >
                    TOT</MDTypography>
            </Grid>
            {/*---------------------------------------------------------------------------------------------*/}
            <Grid item xs={2} md={2} >
                <MDTypography variant="overline" fontWeight="regular"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}>
                   Area espositiva (mt 4x4)
                </MDTypography>
            </Grid>

            <Grid item xs={3} md={3} >
                <MDTypography variant="overline" fontWeight="regular" >
                   Avicunicoli</MDTypography>
            </Grid>

            <Grid item xs={1} md={1} >
                <MDTypography variant="overline" fontWeight="regular" >
                   n°  {q_avi}

                </MDTypography>
            </Grid>
            <Grid item xs={2} md={2} >
                <MDTypography variant="overline" fontWeight="regular" >
                    x  330,00 €

                </MDTypography>
            </Grid>
            <Grid item xs={2} md={2} >
                <MDTypography variant="button" fontWeight="overline" > {currencyFormat(tot_riga)} €</MDTypography>
            </Grid>
            {/*---------------------------------------------------------------------------------------------*/}


        </Grid>

    );

}
Opzione_avi.defaultProps = {
    q_avi:0,
    tot_riga:0
  };
  
  Opzione_avi.propTypes = {
    q_avi: PropTypes.number,
    tot_riga:PropTypes.number
  };
  
  export default Opzione_avi;
  